{
  "snowboards": {
    "preview": [
      {
        "id": 100,
        "img": "https://cdn.shopify.com/s/files/1/0370/3986/5987/products/bataleon-thunderbolt-mens-snowboard-2022-2023-2.jpg?v=1661868352",
        "name": "Bataleon Thunder Bolt",
        "price": 33200,
        "description": "Thunder Bolt піднімає дизайн сноуборду для фрірайду на новий рівень. Наше найлегше серце в поєднанні з преміальним вуглецевим волокном, передовою амортизацією та гоночною основою, яка залишить ваших друзів у пилу. Випускається в строго обмеженій кількості."
      },
      {
        "id": 101,
        "img": "https://cdn.shopify.com/s/files/1/0370/3986/5987/products/bataleon-cameltwo-mens-snowboard-2022-2023-6.jpg?v=1662735111&width=1100",
        "name": "Bataleon Camel Two",
        "price": 21200,
        "description": "Camel Two створений на основі улюбленого шанувальниками Camel Toe. Ми зберегли ті самі звужені лінії, які були секретним інгредієнтом оригінальних плавних поворотів, але надали контуру та профілю носа сучасного стилю. Ми також модернізували дерев’яну серцевину та основу, щоб створити передову дошку, яка буде різати маслянисті плавні лінії через гору та плавати в найглибших умовах."
      },
      {
        "id": 102,
        "img": "https://www.burton.com/static/product/W23/159771_6ML.png?impolicy=bglt&imwidth=568",
        "name": "Burton Throwback",
        "price": 6800,
        "description": "Відродження минулого сноубордингу, чоловічий сноуборд Burton Throwback є зручним для катання, створеним для серфінгу на снігу. Ця дошка готова до розриву, не рекомендовано кататися на курортах, на хардпак чи льоду."
      },
      {
        "id": 103,
        "img": "https://www.burton.com/static/product/W23/10689109000_1.png?impolicy=bglt&imwidth=568",
        "name": "Burton Custom X Camber",
        "price": 33600,
        "description": "Pro-calibre є сильним твердженням для будь-якої дошки, але чоловічий сноуборд Burton Custom X Snowboard неодноразово підходив для найвимогливіших райдерів завдяки точному дизайну та потужному приводу."
      },
      {
        "id": 104,
        "img": "https://www.rossignol.com/media/catalog/product/r/e/relwp45_xv_sashimi_rgb72dpi_01.jpg?optimize=high&bg-color=255,255,255&fit=bounds&height=&width=",
        "name": "ROSSIGNOL XV SASHIMI",
        "price": 27200,
        "description": "XV Sashimi сконструйований і розроблений таким чином, щоб звести межі між грайливим, прогресивним і повним режимами. Розроблено в партнерстві з переможцем 3X FWT Ксав’є Де Ле Рю, що вписалися між серією XV і XV Sushi. М'якший, ніж XV, зручніший, вужчий і довший, ніж XV Sushi, для маневреності та плавучості."
      },
      {
        "id": 105,
        "img": "https://www.rossignol.com/media/catalog/product/r/e/rekwc14_scan_rgb72dpi_01.jpg?optimize=high&bg-color=255,255,255&fit=bounds&height=&width=",
        "name": "ROSSIGNOL XV SASHIMI",
        "price": 9600,
        "description": "Розроблений для райдерів невеликого зросту. Глибокий бічний виріз і надм’яка гнучкість роблять цю подвійну дошку для фрістайлу та надзвичайно легкою для маневрування."
      },
      {
        "id": 106,
        "img": "https://www.salomon.com/en-us/shop/media/catalog/product/L/4/L47032000_d9d0d87bcbea091b03708c781fa8b4ea.png?auto=webp&bg-color=f5f5f5&dpr=1.25&fit=cover&format=pjpg&optimize=low&orient=1&width=810",
        "name": "Salomon SIGHT",
        "price": 11400,
        "description": "Sight — це універсальний сноуборд з формою, натхненною фрірайдом. Звужена спрямована форма покращує відчуття повороту, а поперечний профіль вигину для стабільності на грумерах."
      },
      {
        "id": 107,
        "img": "https://www.salomon.com/en-us/shop/media/catalog/product/L/4/L47031600_efad9e81aaa5c3f1edd08fa611568030.png?auto=webp&bg-color=f5f5f5&dpr=1.25&fit=cover&format=pjpg&optimize=low&orient=1&width=810",
        "name": "Salomon PULSE",
        "price": 10500,
        "description": "Сноуборд Pulse має м'яку гнучкість, що полегшує прогресування та знижує ризик падіння для новачків. Також він має рівний вигин для вільної їзди."
      },
      {
        "id": 108,
        "img": "https://www.salomon.com/en-us/shop/media/catalog/product/L/4/L47031600_efad9e81aaa5c3f1edd08fa611568030.png?auto=webp&bg-color=f5f5f5&dpr=1.25&fit=cover&format=pjpg&optimize=low&orient=1&width=810",
        "name": "Salomon PULSE",
        "price": 10500,
        "description": "Сноуборд Pulse має м'яку гнучкість, що полегшує прогресування та знижує ризик падіння для новачків. Також він має рівний вигин для вільної їзди."
      }
    ],
    "all": [
      {
        "id": 100,
        "img": "https://cdn.shopify.com/s/files/1/0370/3986/5987/products/bataleon-thunderbolt-mens-snowboard-2022-2023-2.jpg?v=1661868352",
        "name": "Bataleon Thunder Bolt",
        "price": 33200,
        "description": "Thunder Bolt піднімає дизайн сноуборду для фрірайду на новий рівень. Наше найлегше серце в поєднанні з преміальним вуглецевим волокном, передовою амортизацією та гоночною основою, яка залишить ваших друзів у пилу. Випускається в строго обмеженій кількості."
      },
      {
        "id": 101,
        "img": "https://cdn.shopify.com/s/files/1/0370/3986/5987/products/bataleon-cameltwo-mens-snowboard-2022-2023-6.jpg?v=1662735111&width=1100",
        "name": "Bataleon Camel Two",
        "price": 21200,
        "description": "Camel Two створений на основі улюбленого шанувальниками Camel Toe. Ми зберегли ті самі звужені лінії, які були секретним інгредієнтом оригінальних плавних поворотів, але надали контуру та профілю носа сучасного стилю. Ми також модернізували дерев’яну серцевину та основу, щоб створити передову дошку, яка буде різати маслянисті плавні лінії через гору та плавати в найглибших умовах."
      },
      {
        "id": 102,
        "img": "https://www.burton.com/static/product/W23/159771_6ML.png?impolicy=bglt&imwidth=568",
        "name": "Burton Throwback",
        "price": 6800,
        "description": "Відродження минулого сноубордингу, чоловічий сноуборд Burton Throwback є зручним для катання, створеним для серфінгу на снігу. Ця дошка готова до розриву, не рекомендовано кататися на курортах, на хардпак чи льоду."
      },
      {
        "id": 103,
        "img": "https://www.burton.com/static/product/W23/10689109000_1.png?impolicy=bglt&imwidth=568",
        "name": "Burton Custom X Camber",
        "price": 33600,
        "description": "Pro-calibre є сильним твердженням для будь-якої дошки, але чоловічий сноуборд Burton Custom X Snowboard неодноразово підходив для найвимогливіших райдерів завдяки точному дизайну та потужному приводу."
      },
      {
        "id": 104,
        "img": "https://www.rossignol.com/media/catalog/product/r/e/relwp45_xv_sashimi_rgb72dpi_01.jpg?optimize=high&bg-color=255,255,255&fit=bounds&height=&width=",
        "name": "ROSSIGNOL XV SASHIMI",
        "price": 27200,
        "description": "XV Sashimi сконструйований і розроблений таким чином, щоб звести межі між грайливим, прогресивним і повним режимами. Розроблено в партнерстві з переможцем 3X FWT Ксав’є Де Ле Рю, що вписалися між серією XV і XV Sushi. М'якший, ніж XV, зручніший, вужчий і довший, ніж XV Sushi, для маневреності та плавучості."
      },
      {
        "id": 105,
        "img": "https://www.rossignol.com/media/catalog/product/r/e/rekwc14_scan_rgb72dpi_01.jpg?optimize=high&bg-color=255,255,255&fit=bounds&height=&width=",
        "name": "ROSSIGNOL XV SASHIMI",
        "price": 9600,
        "description": "Розроблений для райдерів невеликого зросту. Глибокий бічний виріз і надм’яка гнучкість роблять цю подвійну дошку для фрістайлу та надзвичайно легкою для маневрування."
      },
      {
        "id": 106,
        "img": "https://www.salomon.com/en-us/shop/media/catalog/product/L/4/L47032000_d9d0d87bcbea091b03708c781fa8b4ea.png?auto=webp&bg-color=f5f5f5&dpr=1.25&fit=cover&format=pjpg&optimize=low&orient=1&width=810",
        "name": "Salomon SIGHT",
        "price": 11400,
        "description": "Sight — це універсальний сноуборд з формою, натхненною фрірайдом. Звужена спрямована форма покращує відчуття повороту, а поперечний профіль вигину для стабільності на грумерах."
      },
      {
        "id": 107,
        "img": "https://www.salomon.com/en-us/shop/media/catalog/product/L/4/L47031600_efad9e81aaa5c3f1edd08fa611568030.png?auto=webp&bg-color=f5f5f5&dpr=1.25&fit=cover&format=pjpg&optimize=low&orient=1&width=810",
        "name": "Salomon PULSE",
        "price": 10500,
        "description": "Сноуборд Pulse має м'яку гнучкість, що полегшує прогресування та знижує ризик падіння для новачків. Також він має рівний вигин для вільної їзди."
      },
      {
        "id": 108,
        "img": "https://www.salomon.com/en-us/shop/media/catalog/product/L/4/L47031600_efad9e81aaa5c3f1edd08fa611568030.png?auto=webp&bg-color=f5f5f5&dpr=1.25&fit=cover&format=pjpg&optimize=low&orient=1&width=810",
        "name": "Salomon PULSE",
        "price": 10500,
        "description": "Сноуборд Pulse має м'яку гнучкість, що полегшує прогресування та знижує ризик падіння для новачків. Також він має рівний вигин для вільної їзди."
      }
    ]
  }
}
